import {Injectable} from '@angular/core';
import {
  IPlatformCommandHandler,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {Router} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {ScenariosCommandHandlerBase} from '@features/scenarios-core/services/handlers/scenarios-command-handler-base';

@Injectable({
  providedIn: 'root'
})

export class AddScenarioCommandHandler extends ScenariosCommandHandlerBase implements IPlatformCommandHandler {
  constructor(public router: Router,
              public commandService: CommandService,
              public fuseSplashScreenService: FuseSplashScreenService,
              public snackBarService: SnackBarService
  ) {
    super(router, commandService, fuseSplashScreenService, snackBarService);
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.fuseSplashScreenService.show();
    command.projectId = '[PROJECT_ID]';

    // The next two line is for refreshing the previous value manually. There should be a better solution from library level.
    command.fieldValues['HasDialogInput'] = false;
    command.fieldValues['Name'] = '';
    this.commandService.executePlatformCommand(command).subscribe(response => {
      this.fuseSplashScreenService.hide();
      if (response.fieldValues['PlatformCommand']) {
        const commandToExecute = response.fieldValues['PlatformCommand'];
        this.commandService.executePlatformCommand(commandToExecute).subscribe(platformCommandResponse => {
          handler.invalidateSubject.invalidate('Refresh');
        });
      } else if (response.fieldValues['RedirectCommand']) {
        handler.executeCommand(response.fieldValues['RedirectCommand']);
        return;
      } else if (response.fieldValues['RedirectUrl']) {
        handler.invalidateSubject.invalidate('Refresh');
        return;
      }
    });
    return true;
  }
}
